import { render, staticRenderFns } from "./AutomationWizardForm.vue?vue&type=template&id=38dd9634&scoped=true&"
import script from "./AutomationWizardForm.vue?vue&type=script&lang=js&"
export * from "./AutomationWizardForm.vue?vue&type=script&lang=js&"
import style0 from "./AutomationWizardForm.vue?vue&type=style&index=0&id=38dd9634&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dd9634",
  null
  
)

export default component.exports